import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { subHeader_template } from "../components/templates/subHeader_template";
import {vnApp_sentinelbi} from "../components/vnApp_sentinelbi";

declare var page: any;
declare var ko: any;

export class subHeader extends vnModule_knockoutJS {

    protected getModuleName(){
        return "subHeader";
    }

    public subHeader_template: subHeader_template;
    protected XHRHdl: XMLHttpRequestHandler;

    buildContent() : Array<Element>{

        let vnApp : vnApp_sentinelbi = <vnApp_sentinelbi>this.getVnAppZone().app;

        if(vnApp.loggedUser.isLoggedIn) {

            this.subHeader_template = new subHeader_template("subHeader", this.viewModel, this);

            return [this.subHeader_template.build()]
        } else {
            return [];
        }
    }  

    public fillPage() : void {
        let vnApp : vnApp_sentinelbi = <vnApp_sentinelbi>this.getVnAppZone().app;

        if(vnApp.loggedUser.isLoggedIn && !vnApp.isDashboard()){

            this.getMaintenanceAlert();
            this.getIsPixelInstalled();
        }
    }

    public getMaintenanceAlert() {

        let baseApiUrl: string = '/api/maintenanceAlert/';
        let params: Array<Array<string>> = [];

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(baseApiUrl, params, this);

        XHRHdl.onReadyStateFunction = this.onGetMaintenanceAlert;
        XHRHdl.execute();
    }

    protected onGetMaintenanceAlert(req: any, obj: any): Function{
        
        return function() {

            obj.manageResponse(req, obj, function(){

                let maintenanceContent = JSON.parse(req.request.response);

                if(maintenanceContent){

                    obj.subHeader_template.setMaintenanceHtml(maintenanceContent)
                }
            });
        }
    }

    public getIsPixelInstalled(){

        let baseApiUrl: string = '/api/isPixelInstalled/';
        let params: Array<Array<string>> = [];

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(baseApiUrl, params, this);

        XHRHdl.onReadyStateFunction = this.onGetIsPixelInstalled;
        XHRHdl.execute();
    }

    public onGetIsPixelInstalled(req: any, obj: any){

        return function() {

            obj.manageResponse(req, obj, function() {
                
                let result = JSON.parse(req.request.response);

                if(result){

                    obj.subHeader_template.setPixelAlert(result);
                }

            });
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/subHeader.ts